import { useEffect } from 'react';
import type { CopilotSession } from '@customerio/hydra-copilot';

/**
 * Re-reads the open conversation when the window gets focus again, so a chat
 * that another window or tab moved on catches up. Only a newer exchange from
 * elsewhere replaces the local log.
 */
export function useCopilotSessionRefreshOnFocus(session: Pick<CopilotSession, 'refresh'>) {
  useEffect(() => {
    function handleFocus() {
      void session.refresh({ onlyIfChangedElsewhere: true });
    }

    window.addEventListener('focus', handleFocus);
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, [session]);
}
